import { Box, Stack } from '@mui/material';
import React from 'react';
import {
    DashboardActivityChart,
    DashboardKpiCard,
    DashboardKpiRow,
    DashboardStatusBreakdown,
    useAllowedPath
} from '../../sections/@dashboard/app';
import { formatCurrency } from '../../utils/formatNumber';
import i18n from '../../i18n';

const TILES = [
    { key: 'total', icon: 'eva:layers-outline', color: 'primary' },
    { key: 'available', icon: 'eva:credit-card-outline', color: 'success' },
    { key: 'received', icon: 'eva:diagonal-arrow-left-down-outline', color: 'info', path: '/app/payin-instances' }
];

/** The merchant dashboard: three balance figures, orders by day and by status. */
export default function MerchantDashboardContent({ data, isLoading }) {
    const allowed = useAllowedPath();
    const ordersByDate = data?.ordersByDate || {};
    const paymentOrders = data?.paymentOrders || {};
    const labels = data?.datesLabelsPaymentOrders || [];
    const balance = data?.balance || {};

    const t = (key) => i18n.t(`dashboard.balance.details.${key}`);

    return (
        <Stack spacing={3}>
            <DashboardKpiRow>
                {TILES.map((tile) => (
                    <DashboardKpiCard
                        key={tile.key}
                        loading={isLoading}
                        title={t(`${tile.key}.title`)}
                        tooltip={t(`${tile.key}.tooltip`)}
                        value={formatCurrency(balance[`${tile.key}Balance`] || 0)}
                        icon={tile.icon}
                        color={tile.color}
                        to={tile.path && allowed(tile.path)}
                    />
                ))}
            </DashboardKpiRow>
            {/* A CSS grid, not <Grid container>: inside a Stack the
                container's negative margins are reset and it overhangs. */}
            <Box
                sx={{
                    display: 'grid',
                    gap: 3,
                    gridTemplateColumns: { xs: 'minmax(0, 1fr)', lg: 'minmax(0, 2fr) minmax(0, 1fr)' }
                }}
            >
                    <DashboardActivityChart
                        loading={isLoading}
                        title={i18n.t('dashboard.ordersByDate')}
                        labels={labels}
                        series={Object.entries(ordersByDate).map(([name, series]) => ({
                            name: i18n.t(`dashboard.${name}`),
                            data: series
                        }))}
                    />

                    <DashboardStatusBreakdown
                        loading={isLoading}
                        title={i18n.t('dashboard.paymentOrdersByStatus')}
                        data={Object.entries(paymentOrders).map(([label, value]) => ({
                            label,
                            value: Number(value) || 0
                        }))}
                    />
            </Box>
        </Stack>
    );
}
